import { Form, FormGroup, Input, Row, Col, Button } from 'reactstrap';
import { CommentSectionWrapper } from './CommentSection.styled';
import { useState, useEffect } from "react";
import { db } from "../../../firebase";

import {
   collection,
   addDoc,
   onSnapshot,
   query,
   orderBy
} from "firebase/firestore";

function CommentSection() {
   const [comments, setComments] = useState<any>([]);
   const [input, setInput] = useState("");

   // Real-time listener
   useEffect(() => {
      const q = query(collection(db, "comments"), orderBy("createdAt", "desc"));

      const unsubscribe = onSnapshot(q, (snapshot) => {
         const data = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
         }));
         setComments(data);
      });

      return () => unsubscribe(); // cleanup
   }, []);

   // ➕ Add comment
   const handleSubmit = async (e: any) => {
      e.preventDefault();
      if (!input.trim()) return;

      await addDoc(collection(db, "comments"), {
         text: input,
         createdAt: new Date()
      });

      setInput("");
   };

   return (
      <CommentSectionWrapper>
         <div className="site-content">
            <hr />
            <h2 className="text-align-left">Leave a Reply</h2>
            <br />
            <Form className="text-align-left" onSubmit={handleSubmit}>
               <FormGroup>
                  <Input id="comment" name="comment" type="textarea" required onChange={(e) => setInput(e.target.value)} />
               </FormGroup>
               <Row>
                  <Col sm="2" md="4">
                     <FormGroup>
                        <Input id="name" name="name" placeholder="Name" type="text" required />
                     </FormGroup>
                  </Col>
                  <Col sm="2" md="4">
                     <FormGroup>
                        <Input id="email" name="email" placeholder="Email" type="email" required />
                     </FormGroup>
                  </Col>
                  <Col sm="2" md="4">
                     <FormGroup>
                        <Input id="webiste" name="website" placeholder="Website" type="text" />
                     </FormGroup>
                  </Col>
               </Row>
               <br />
               <Button style={{ backgroundColor: '#647f19', borderColor: '#647f19' }} type="submit">Post Comment</Button>
            </Form>
            <br />
            {comments && <h3 className="text-align-left">Comments</h3>}
            <div style={{textAlign: "left" }}>
               {comments.map((c: any) => {
                  const date = c.createdAt?.toDate
                     ? c.createdAt.toDate()
                     : new Date(c.createdAt);

                  return (
                     <div key={c.id} className="comments">
                        {/* Comment Text */}
                        <p style={{ fontSize: "15px",  marginBottom: "auto", textAlign: 'justify'}}>
                           {c.text}
                        </p>

                        {/* Timestamp */}
                        <p style={{ fontSize: "10px", color: "#777", textAlign: "right", marginBottom: "auto"}}>
                           {date.toLocaleString()}
                        </p>
                     </div>
                  );
               })}
            </div>
            <br />
         </div>
      </CommentSectionWrapper>
   )
};

export default CommentSection;
